import { Fragment, useEffect, useState } from "react";
import "./userlist.css";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { deleteUser, getUsers } from "../../actions/userActions";
import { clearError, clearUserDeleted } from "../../slices/userSlice";
import Loader from "../layouts/Loader";
import { toast } from "react-toastify";
import Sidebar from "./Sidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Pagination from "react-js-pagination";
import { Modal, Box, Typography } from "@mui/material";
import {
  faCartShopping,
  faFilter,
  faPencil,
  faSearch,
  faTrash,
  faDashboard,
  faList,
  faShoppingBag,
  faSort,
  faUserPlus,
} from "@fortawesome/free-solid-svg-icons";
import { Dropdown } from "react-bootstrap";
import Drawer from "@mui/material/Drawer";
import MetaData from "../layouts/MetaData";
import XLSX from "xlsx-js-style";
import axios from "axios";

export default function CreateAnnouncements() {
  // Drawer
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  // Navbar
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1000);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1000);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <MetaData title="User List | GLOCRE" />
      <section className="userlist-glc">
        <div className="row container-fluid">
          <div className="col-12 col-md-2">
            <Sidebar />
          </div>
          <div className="col-12 col-lg-10 col-md-12 pr-0">
            <div className="mobile-logo">
              <Link to="/">
                <img
                  src={require("../../images/procure-g-logo.png")}
                  alt="mobile-logo"
                />
              </Link>
            </div>

            <div className="breadcrumbWrapperr">
              {/* Breadcrumbs & Menu Icon Row (For Mobile) */}
              {isMobile ? (
                <div className="row mobile-topbar">
                  <div className="col-10">
                    <ul className="breadcrumb breadcrumb2 mb-0">
                      <li>
                        <Link to="/admin/dashboard" style={{ color: "#fff" }}>
                          Dashboard
                        </Link>
                      </li>
                      <li>Create Announcement</li>
                    </ul>
                  </div>
                  <div className="col-2 p-0 d-flex justify-content-center align-items-center">
                    <button className="fab" onClick={toggleDrawer}>
                      <FontAwesomeIcon icon={faList} />
                    </button>
                  </div>
                </div>
              ) : (
                <div className="row dash-navbar-big-glc small-sticky-navbar">
                  <div className="col-lg-3 col-md-12">
                    <ul className="breadcrumb breadcrumb2 mb-0">
                      <li>
                        <Link to="/admin/dashboard">Dashboard</Link>
                      </li>
                      <li>Create Announcement</li>
                    </ul>
                  </div>
                  <div className="col-lg-7 col-md-6 d-flex justify-content-end align-items-end">
                    <div className="dash-cont-glc">
                      <div className="row">
                        <div className="topnav">
                          <div className="search-container">
                            <form className="d-flex">
                              <input
                                type="text"
                                placeholder="Search"
                                name="search"
                              />
                              <button type="submit">
                                <FontAwesomeIcon icon={faSearch} />
                              </button>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-1 col-md-2 d-flex justify-content-center align-items-end">
                    <Dropdown className="d-inline">
                      <Dropdown.Toggle
                        variant="default"
                        id="dropdown-basic"
                        className="custom-filter-toggle"
                      >
                        <FontAwesomeIcon icon={faFilter} />
                      </Dropdown.Toggle>
                    </Dropdown>
                  </div>
                </div>
              )}
              {/* Search, Filter & Avatar Row (For Mobile) */}
              {isMobile && (
                <div className="row mobile-bottombar">
                  <div className="col-9 col-md-10 pr-0">
                    <div className="search-container">
                      <form className="d-flex">
                        <input type="text" placeholder="Search" name="search" />
                        <button type="submit">
                          <FontAwesomeIcon icon={faSearch} />
                        </button>
                      </form>
                    </div>
                  </div>
                  <div className="col-3 col-md-2  d-flex justify-content-center align-items-end">
                    <Dropdown className="d-inline">
                      <Dropdown.Toggle
                        variant="default text-white"
                        id="dropdown-basic"
                        className="text-dark dropdown1 icon-list-filter-procureg"
                        style={{
                          backgroundImage: "none",
                          border: "none",
                          boxShadow: "none",
                        }}
                      >
                        <FontAwesomeIcon icon={faFilter} />
                      </Dropdown.Toggle>
                    </Dropdown>
                  </div>
                </div>
              )}
              {/* Drawer Component */}
              <Drawer
                open={isDrawerOpen}
                onClose={toggleDrawer}
                direction="right"
                className="drawer"
              >
                <div className="drawer-header">
                  ADMIN DASHBOARD
                  {/* <button className="drawer-close-btn" onClick={toggleDrawer}>&times;</button> */}
                </div>
                <div className="drawer-content">
                  <ul className="drawer-links">
                    <li>
                      <Link to="/admin/dashboard">
                        <FontAwesomeIcon icon={faDashboard} /> &nbsp;Dashboard
                      </Link>
                    </li>
                    <li>
                      <Link to="/admin/products">
                        <FontAwesomeIcon icon={faCartShopping} /> &nbsp;Product
                        List
                      </Link>
                    </li>
                    <li>
                      <Link to="/admin/products/create">
                        <FontAwesomeIcon icon={faShoppingBag} /> &nbsp;Create
                        Product
                      </Link>
                    </li>
                    <li>
                      <Link to="/admin/orders">
                        <FontAwesomeIcon icon={faSort} /> &nbsp;Order List
                      </Link>
                    </li>
                    <li>
                      <Link to="/admin/users">
                        <FontAwesomeIcon icon={faUserPlus} /> &nbsp;User List
                      </Link>
                    </li>
                    <li>
                      <Link to="/admin/reviews">
                        <FontAwesomeIcon icon={faPencil} /> &nbsp;Review List
                      </Link>
                    </li>
                    <li>
                      <Link to="/admin/edit-banner">
                        <FontAwesomeIcon icon={faPencil} className="me-2" />
                        Banner
                      </Link>
                    </li>
                    <li>
                      <Link to="/admin/awsimages">
                        <FontAwesomeIcon icon={faPencil} className="me-2" />
                        Images
                      </Link>
                    </li>
                    <li>
                      <Link to="/admin/subscribers">
                        <FontAwesomeIcon icon={faPencil} className="me-2" />
                        All Emails
                      </Link>
                    </li>
                  </ul>
                </div>
              </Drawer>
            </div>

            <div
              className="d-flex justify-content-between align-items-center flex-wrap"
              style={{ marginTop: "40px" }}
            >
              <h3 className="" style={{ color: "#ffad63", margin: 0 }}>
                CREATE ANNOUNCEMENT
              </h3>
            </div>

            {/* Create announcment form */}
            <CreateAnnouncementss />
          </div>
        </div>
      </section>
    </>
  );
}

// create Announcement modal
function CreateAnnouncementss() {
  const navigate = useNavigate();
  const [previewImage, setPreviewImage] = useState(null);

  const [formData, setFormData] = useState({
    type: "",
    subject: "",

    mainHeading: "",
    mainParagraph: "",

    listHeading: "",
    listItems: ["", "", "", ""],

    subHeading: "",
    subParagraphs: ["", ""],

    image: null,
    attachmentPdf: null,
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      const file = files[0];

      setFormData((prev) => ({
        ...prev,
        [name]: file,
      }));

      if (name === "image") {
        setPreviewImage(URL.createObjectURL(file));
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  // LIST ITEMS
  const handleListChange = (index, value) => {
    const updated = [...formData.listItems];

    updated[index] = value;

    setFormData({
      ...formData,
      listItems: updated,
    });
  };

  // SUB PARAGRAPHS
  const handleSubParagraphChange = (index, value) => {
    const updated = [...formData.subParagraphs];

    updated[index] = value;

    setFormData({
      ...formData,
      subParagraphs: updated,
    });
  };

  // ADD LIST ITEM
  const addListItem = () => {
    setFormData({
      ...formData,
      listItems: [...formData.listItems, ""],
    });
  };

  // REMOVE LIST ITEM
  const removeListItem = (index) => {
    const updated = formData.listItems.filter((_, i) => i !== index);

    setFormData({
      ...formData,
      listItems: updated,
    });
  };

  // ADD SUB PARA
  const addSubParagraph = () => {
    setFormData({
      ...formData,
      subParagraphs: [...formData.subParagraphs, ""],
    });
  };

  // REMOVE SUB PARA
  const removeSubParagraph = (index) => {
    const updated = formData.subParagraphs.filter((_, i) => i !== index);

    setFormData({
      ...formData,
      subParagraphs: updated,
    });
  };

  const resetForm = () => {
    setFormData({
      type: "",
      subject: "",

      mainHeading: "",
      mainParagraph: "",

      listHeading: "",
      listItems: ["", "", "", ""],

      subHeading: "",
      subParagraphs: ["", ""],

      image: null,
      attachmentPdf: null,
    });

    setPreviewImage(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const form = new FormData();

      form.append("type", formData.type);
      form.append("subject", formData.subject);

      form.append("mainHeading", formData.mainHeading);
      form.append("mainParagraph", formData.mainParagraph);

      form.append("listHeading", formData.listHeading);
      form.append("listItems", JSON.stringify(formData.listItems));

      form.append("subHeading", formData.subHeading);
      form.append("subParagraphs", JSON.stringify(formData.subParagraphs));

      if (formData.image) {
        form.append("image", formData.image);
      }

      if (formData.attachmentPdf) {
        form.append("pdf", formData.attachmentPdf);
      }

      await axios.post("/api/v1/admin/announcement", form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success("Announcement Created Successfully");

      resetForm();
      navigate("/admin/announcements");
    } catch (error) {
      console.error(error);

      toast.error(error.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <div className="">
      <form onSubmit={handleSubmit}>
        <div className="row">
          {/* TYPE */}
          <div className="col-md-6 mb-3">
            <label className="announcement-label">Type</label>

            <select
              name="type"
              className="form-control"
              value={formData.type}
              onChange={handleChange}
              style={{ fontSize: "14px" }}
              required
            >
              <option value="">Select Type</option>

              <option value="Business">Business</option>
              <option value="Alert">Alert</option>
              <option value="Legal">Legal</option>
              <option value="People">People</option>
              <option value="Expertise">Expertise</option>
            </select>
          </div>

          {/* SUBJECT */}
          <div className="col-md-6 mb-3">
            <label className="announcement-label">Subject</label>

            <input
              type="text"
              name="subject"
              className="form-control"
              value={formData.subject}
              onChange={handleChange}
              required
            />
          </div>

          {/* MAIN HEADING */}
          <div className="mb-3">
            <label className="announcement-label">Main Heading</label>

            <input
              type="text"
              name="mainHeading"
              className="form-control"
              value={formData.mainHeading}
              onChange={handleChange}
            />
          </div>

          {/* MAIN PARA */}
          <div className="mb-3">
            <label className="announcement-label">Main Paragraph</label>

            <textarea
              name="mainParagraph"
              className="form-control"
              value={formData.mainParagraph}
              onChange={handleChange}
              style={{ minHeight: "150px" }}
            />
          </div>

          {/* LIST HEADING */}
          <div className="mb-3">
            <label className="announcement-label">List Heading</label>

            <input
              type="text"
              name="listHeading"
              className="form-control"
              value={formData.listHeading}
              onChange={handleChange}
            />
          </div>

          {/* LIST ITEMS */}
          <div className="mb-3">
            <label className="announcement-label">List Items</label>

            {formData.listItems.map((item, index) => (
              <div key={index} className="d-flex mb-2">
                <input
                  type="text"
                  className="form-control"
                  value={item}
                  onChange={(e) => handleListChange(index, e.target.value)}
                />

                <button
                  type="button"
                  className="btn btn-danger ms-2"
                  onClick={() => removeListItem(index)}
                >
                  X
                </button>
              </div>
            ))}

            <button
              type="button"
              className="btn btn-secondary"
              onClick={addListItem}
              style={{ fontSize: "14px" }}
            >
              + Add Item
            </button>
          </div>

          {/* SUB HEADING */}
          <div className="mb-3">
            <label className="announcement-label">Sub Heading</label>

            <input
              type="text"
              name="subHeading"
              className="form-control"
              value={formData.subHeading}
              onChange={handleChange}
              style={{ fontSize: "14px" }}
            />
          </div>

          {/* SUB PARAGRAPHS */}
          <div className="mb-3">
            <label className="announcement-label">Sub Paragraphs</label>

            {formData.subParagraphs.map((para, index) => (
              <div key={index} className="mb-2">
                <textarea
                  className="form-control"
                  value={para}
                  onChange={(e) =>
                    handleSubParagraphChange(index, e.target.value)
                  }
                  style={{ minHeight: "120px" }}
                />

                <button
                  type="button"
                  className="btn btn-danger mt-2"
                  onClick={() => removeSubParagraph(index)}
                >
                  Remove
                </button>
              </div>
            ))}

            <button
              type="button"
              className="btn btn-secondary"
              onClick={addSubParagraph}
            >
              + Add Paragraph
            </button>
          </div>

          {/* IMAGE */}
          <div className="col-md-6 mb-3">
            <label className="announcement-label">Upload Image</label>

            <input
              type="file"
              name="image"
              className="form-control"
              accept="image/*"
              onChange={handleChange}
            />

            {previewImage && (
              <img
                src={previewImage}
                alt="preview"
                style={{
                  width: "80px",
                  height: "80px",
                  marginTop: "10px",
                  objectFit: "cover",
                }}
              />
            )}
          </div>

          {/* PDF */}
          <div className="col-md-6 mb-3">
            <label className="announcement-label">Upload PDF</label>

            <input
              type="file"
              name="attachmentPdf"
              className="form-control"
              accept="application/pdf"
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="announcement-modal-actions mt-3">
          <button
            type="button"
            type="reset"
            className="announcement-cancel-btn me-2"
          >
            Cancel
          </button>

          <button type="submit" className="announcement-submit-btn">
            Submit
          </button>
        </div>
      </form>
    </div>
  );
}
